import React from 'react'

const SvgMugOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.5 8c1.333 0 2 .667 2 2v1c2.667 0 4 1.333 4 3.999v1c0 2.667-1.333 4.001-4 4.001 0 1.333-.666 2-1.999 2H5.5c-1.333 0-2-.667-2-2V10c0-1.333.667-2 2-2h9zm0 2h-9v10h9V10zm2 3v5c1.273 0 1.938-.607 1.996-1.822L18.5 16v-.997c0-1.335-.667-2.003-2-2.003zM7.505 2c.663 0 .995.333.995 1v3c0 .667-.334 1-1 1-.666 0-1-.333-1-1V3c.006-.667.341-1 1.005-1zM11.5 4c.666 0 1 .333 1 1v1c0 .667-.332 1-.996 1-.663 0-.998-.333-1.004-1V5c0-.667.334-1 1-1z'
    />
  </svg>
)

export default SvgMugOutline
